import { buildSlice, CommonState } from '~libs/reduxUtils';

import { typePrefix } from '~care-workers/actions';
import { getAll, getOne } from '~lookups/actions/calendarFrequencies';

import { CalendarFrequency } from '../models';

const initialState: CommonState<CalendarFrequency> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  row: undefined,
};

const slice = buildSlice<CommonState<CalendarFrequency>, CalendarFrequency>(typePrefix, initialState, {
  commonConfig: { getAll, getOne },
});

export const { clear, updateParams } = slice.actions;
export default slice.reducer;
